import { NgModule } from '@angular/core';
import { IonicModule } from 'ionic-angular';
import { ChatInputComponent } from './chat-input';
import { UploadButtonComponentModule } from '../upload-button/upload-button.module';
import { DirectivesModules } from '../../directives/directives.modules';
import { KintipsAvatarComponentModule } from '../kintips-avatar/kintips-avatar.module';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [
    ChatInputComponent
  ],
  imports: [
    IonicModule,
    UploadButtonComponentModule,
    DirectivesModules,
    KintipsAvatarComponentModule,
    TranslateModule.forChild(),
  ],
  exports: [
    ChatInputComponent
  ]
})
export class ChatInputComponentModule {}



// WEBPACK FOOTER //
// ./src/components/chat-input/chat-input.module.ts